import Grid from "@mui/material/Grid";
import { useEffect, useRef, useState } from "react";
import BuildIdLogo from "../../assets/images/build_id_logo.png";
import {
  Box,
  Button,
  Card,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { Check, Clear, Visibility, VisibilityOff } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import CryptoJS from "crypto-js";
import {
  FORGOTPASSWORD,
  GET_APP_LABELS_LANGUAGES_DETAILS,
  ISVALIDRESETCODE,
  LOGIN,
  SEND_RESET_PASSWORD,
  UPDATE_RESET_PASSWORD
} from "../../constant/Apipath";
import { EMAIL } from "../../assets/helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  setLogindata,
  setMultiLanguageCode,
  setMultiLanguageData,
  setSelectedClientdata,
  setShowalert,
  setShowmapmodal
} from "../../redux/actions/actions";
import "./Login.css";
import { BIBlue, BIGreen, BIGrey, BILightGrey, BIRed, BIYellow } from "../../assets/helpers";
import { Getrequestcall } from "../../request/Getrequest";
import Loader from "../../common/Loader";
import Bowser from "bowser";
import TakeTour from "./takeatour/TakeTour";
import { English } from "../../constant/EnglishFallback";
import { getToken } from "../../firebase/firebase";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { getUserinformation } from "./userService";
import { fetchAndStoreCommunityPostIds } from "../../services/communityService";

import { SelectOrganizationDialog } from "./SelectOrganization";
import ClientInvitation from "../../client/invitation/ClientInvitation";
import { clearIndexDB } from "../../db";

const labelArray = [
  { language: "English", code: "en" },
  { language: "Hindi", code: "hi" },
  { language: "French", code: "fr" },
  { language: "Spanish", code: "es" },
  { language: "Afrikaans", code: "af" }
];

export default function Login() {
  const { pathname } = useLocation();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const chooseLang = useSelector((state) => state?.main?.selectedLanguage);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [notifyToken, setNotifytoken] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [inputValue, setInputvalue] = useState({
    email: "",
    password: ""
  });
  const [showVisibilityIcon, setShowVisibilityIcon] = useState(false);
  const [activeForm, setActiveForm] = useState("isLoading");
  const [selectedLanguage, setSelectedLanguage] = useState(chooseLang || "en");
  const [resetCode, setResetCode] = useState(null);
  const [passwordStrengthCount, setPasswordStrengthCount] = useState(0);
  const [retypePassword, setRetypePassword] = useState("");
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const [changeLangLoader, setChangeLangLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const browser = Bowser.getParser(window.navigator.userAgent);
  const { email, guideId } = useParams();
  const isInitialRender = useRef(true);
  const info = browser.getResult();
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIphone = /iPhone/i.test(navigator.userAgent);
  const isIpad = /iPad/i.test(navigator.userAgent);
  const isMatch = inputValue?.password === retypePassword && retypePassword !== "";

  const {
    TEXT_LOGIN = English?.Login.TEXT_LOGIN,
    TEXT_EMAIL = English?.Login.TEXT_EMAIL,
    TEXT_PASSWORD = English?.Login.TEXT_PASSWORD,
    TEXT_FORGOT_PASSWORD = English?.Login.TEXT_FORGOT_PASSWORD,
    TEXT_CREATE_NEW_ACCOUNT = English?.Login.TEXT_CREATE_NEW_ACCOUNT,
    TEXT_DESCIPTION_1 = English?.Login.TEXT_DESCIPTION_1,
    TEXT_DESCIPTION_2 = English?.Login.TEXT_DESCIPTION_2,
    SNACKBAR_RESET_PASSWORD = English?.Login?.SNACKBAR_RESET_PASSWORD,
    TEXT_INVALID_EMAIL = English?.Login?.TEXT_INVALID_EMAIL,
    TEXT_PASSWORD_CHANGED = English?.Login?.TEXT_PASSWORD_CHANGED
  } = multiLanguageData?.Login || {};

  const {
    TEXT_CHARACTERS = English?.ChangePassword?.TEXT_CHARACTERS,
    TEXT_NUMBER = English?.ChangePassword?.TEXT_NUMBER,
    TEXT_CAPITAL_LETTER = English?.ChangePassword?.TEXT_CAPITAL_LETTER,
    TEXT_LOWER_LETTER = English?.ChangePassword?.TEXT_LOWER_LETTER,
    TEXT_NEW_PASS_LABEL = English?.ChangePassword?.TEXT_NEW_PASS_LABEL,
    TEXT_PASS_STRENGTH = English?.ChangePassword?.TEXT_PASS_STRENGTH,
    TEXT_CONFIRM_PASS_LABEL = English?.ChangePassword?.TEXT_CONFIRM_PASS_LABEL,
    TEXT_STRONG_PASS = English?.ChangePassword?.TEXT_STRONG_PASS,
    TEXT_MEDIUM_PASS = English?.ChangePassword?.TEXT_MEDIUM_PASS,
    TEXT_WEAK_PASS = English?.ChangePassword?.TEXT_WEAK_PASS,
    TEXT_RESET_PASSWORD = English?.ChangePassword?.TEXT_RESET_PASSWORD
  } = multiLanguageData?.ChangePassword || {};

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const location = useLocation();
  const [fromUserTickets, setFromUserTickets] = useState(false);
  const ticketId = useRef(null);

  const inputValuechange = (e) => {
    let { name, value } = e.target;

    // Remove leading non-alphanumeric characters
    value = value.replace(/^[^A-Za-z0-9]+/, "");

    // Toggle visibility icon
    setShowVisibilityIcon(value !== "");

    // Update state with sanitized value
    setInputvalue({
      ...inputValue,
      [name]: value
    });
  };

  async function getDeviceId() {
    const visitorId = await getCurrentBrowserFingerPrint();
    return visitorId;
  }

  const [showClientModal, setShowClientModal] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [pendingLoginRes, setPendingLoginRes] = useState(null);
  const [showInvitationModal, setShowInvitationModal] = useState(false);

  const handleLoginClick = async () => {
    const { email, password } = inputValue;
    const hash = CryptoJS.SHA256(password).toString();
    const deviceId = await getDeviceId();
    clearIndexDB();
    setIsLoading(true);
    try {
      const loginObj = {
        AppName: "BuildID Web",
        Email: email,
        Password: hash,
        DeviceName: "Browser",
        Browser: info.browser.name || "Unknown",
        BrowserVersion: info.browser.version || "Unknown",
        Platform: info.os.name || "Unknown",
        PlatformVersion: info.os.version || "NA",
        NotifyToken: notifyToken || null,
        DeviceId: deviceId
      };
      let getLoginresponse = await Postrequestcall(LOGIN, loginObj, null);
      if (getLoginresponse.status === 200) {
        let mapModal = {
          open: false,
          from: "",
          select: ""
        };
        const loginRes = getLoginresponse?.data?.data;
        dispatch(setShowmapmodal(mapModal));
        const userInfo = await getUserinformation(loginRes, deviceId);
        const hasClients =
          userInfo.userInformation?.ClientsList &&
          userInfo.userInformation.ClientsList.some((c) => c.HideBiFree);
        const hasInvites = userInfo?.userInformation?.PendingInvitations?.length > 0;
        if (userInfo && (hasClients || hasInvites)) {
          // Show Select Organization Modal if there are clients OR pending invitations
          setPendingLoginRes(userInfo);
          const clients = userInfo.userInformation.ClientsList.filter(
            (c) => c.OrganizationName !== "BuildID Free"
          );
          setClientList(clients);
          setShowClientModal(true);
        } else {
          dispatch(setLogindata(userInfo));
          fetchAndStoreCommunityPostIds(
            userInfo?.userInformation?.UserId,
            userInfo?.accessToken,
            dispatch
          );
          const ticketId = sessionStorage.getItem("userTicketId");
          if (ticketId) {
            sessionStorage.removeItem("userTicketId");
            navigate(`/user-tickets/${ticketId}`, { replace: true });
          } else {
            navigate("/home");
          }
        }
      } else if (getLoginresponse.status === 401) {
        let msg = getLoginresponse?.data?.errorMessage || getLoginresponse?.data?.message;
        handleShowAlert(msg);
      }
    } catch (error) {
      console.log("handleLoginClick-> Error When Getting Login Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectClient = async (client) => {
    // Now we commit the login state to Redux
    dispatch(setSelectedClientdata(client));
    dispatch(setLogindata(pendingLoginRes));
    fetchAndStoreCommunityPostIds(
      pendingLoginRes?.userInformation?.UserId,
      pendingLoginRes?.accessToken,
      dispatch
    );
    const ticketId = sessionStorage.getItem("userTicketId");
    if (ticketId) {
      sessionStorage.removeItem("userTicketId");
      navigate(`/user-tickets/${ticketId}`);
    } else if (client.ClientId && client.ClientId !== 0) {
      navigate(`/client/${client.ClientId}/home`);
    } else {
      navigate("/home");
    }
    setShowClientModal(false);
  };

  const handleLogoutInModal = () => {
    // Just close modal and clear temp state, effectively "logging out" of the pending state
    setShowClientModal(false);
    setPendingLoginRes(null);
    setClientList([]);
  };

  const handleViewPendingInvite = (invite) => {
    // We update the local pending state to include the invitation details we want to view
    // NOT dispatching to global Redux yet to prevent redirection to /home
    const updatedUserInfo = {
      ...pendingLoginRes,
      userInformation: {
        ...pendingLoginRes.userInformation,
        ClientInvitation: {
          ClientId: invite.ClientId,
          UserEmail: invite.UserEmail,
          Status: 1
        }
      }
    };

    setPendingLoginRes(updatedUserInfo);
    setShowClientModal(false); // Close Org Select
    setShowInvitationModal(true); // Open Invite Modal
  };

  const handleInviteModalClose = async () => {
    setShowInvitationModal(false);
    setIsLoading(true);

    try {
      const deviceId = await getDeviceId();
      // Fetch fresh data from API
      const updatedUserInfo = await getUserinformation(pendingLoginRes, deviceId);

      if (updatedUserInfo) {
        setPendingLoginRes(updatedUserInfo);
        const clients = (updatedUserInfo.userInformation.ClientsList || []).filter(
          (c) => c.OrganizationName !== "BuildID Free"
        );
        setClientList(clients);
      }
    } catch (error) {
      console.log("Error refreshing user info:", error);
    } finally {
      setIsLoading(false);
      setShowClientModal(true);
    }
  };

  const handleCreateAccount = () => {
    navigate("/create-account");
  };

  const handleForgotPasswordClick = async () => {
    try {
      const { email } = inputValue;
      if (!EMAIL.test(email)) {
        handleShowAlert(TEXT_INVALID_EMAIL);
        return;
      }
      setActiveForm("isLoading");
      const obj = {
        Email: email
      };
      const res = await Getrequestcall(`${SEND_RESET_PASSWORD}${email}`);
      if (res?.data?.status === false) {
        let msg = res?.data?.message || res?.data?.errorMessage;
        if (msg === "USER_NOT_FOUND") {
          handleShowAlert("User Not Found");
        } else {
          handleShowAlert(msg);
        }
        setActiveForm("login-form");
      } else if (res?.data?.message === "OK") {
        handleShowAlert(SNACKBAR_RESET_PASSWORD);
        setActiveForm("login-form");
      }
    } catch (err) {
      console.log("handleForgotPasswordClick-> Error When Trying To Send Reset Mail: ", err);
      setActiveForm("login-form");
    }
  };

  const handleContinueClick = async () => {
    const { email } = inputValue;
    if (!email) {
      handleShowAlert("Please provide an email address!");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      handleShowAlert(TEXT_INVALID_EMAIL);
      return;
    }
    try {
      setActiveForm("isLoading");
      const forgotPasswordRes = await Getrequestcall(`${FORGOTPASSWORD}/${email}`);
      if (forgotPasswordRes?.data?.errorMessage && forgotPasswordRes?.data?.status === false) {
        handleShowAlert(forgotPasswordRes?.data?.errorMessage);
        setActiveForm("forgot-password-form");
        return;
      } else if (forgotPasswordRes?.data?.message === "OK") {
        setActiveForm("reset-code-form");
      }
    } catch (error) {
      console.log(
        "handleContinueClick-> Error When Changing Password: ",
        error || error?.errorMessage
      );
    }
  };

  const handleGotoResetCode = () => {
    const { email } = inputValue;
    if (email === "") {
      handleShowAlert("Please provide an email address!");
    } else {
      setActiveForm("reset-code-form");
    }
  };

  const handleResendCodeClick = () => {
    const { email } = inputValue;
    handleShowAlert(`Varification code has been resent to ${email}`);
    setActiveForm("reset-code-form");
  };

  const handleResetClick = async () => {
    const { email } = inputValue;
    try {
      setActiveForm("isLoading");
      const resetCodeobj = {
        Email: email,
        resetCode: resetCode,
        NotifyToken: "",
        AppName: "BuilID-Web",
        AppVersion: "3.10",
        Browser: info.browser.name || "Unknown",
        BrowserVersion: info.browser.version || "Unknown",
        Platform: info.os.name || "Unknown",
        PlatformVersion: info.os.version || "NA",
        DeviceName: "125879654"
      };

      const isValidResetCodeRes = await Postrequestcall(ISVALIDRESETCODE, resetCodeobj);
      if (isValidResetCodeRes?.data?.errorMessage && isValidResetCodeRes?.data?.status === false) {
        handleShowAlert(isValidResetCodeRes?.data?.errorMessage);
        setResetCode(null);
        setActiveForm("reset-code-form");
      } else if (isValidResetCodeRes?.data?.data?.id) {
        dispatch(setLogindata(isValidResetCodeRes?.data?.data));
        setActiveForm("change-password-form");
        setResetCode(null);
      }
    } catch (error) {
      console.log("handleResetClick-> Error When Verifying Reset Code: ", error);
      setActiveForm("reset-code-form");
    }
  };

  const handleChangePassword = async () => {
    if (email && guideId) {
      setActiveForm("isLoading");
      const hashPassword = CryptoJS.SHA256(inputValue?.password).toString();
      try {
        const obj = {
          email: email,
          guideId: guideId,
          password: hashPassword
        };
        const res = await Postrequestcall(UPDATE_RESET_PASSWORD, obj, undefined);
        if (res?.data?.message !== "OK" && res?.data?.status === false) {
          let msg = res?.data?.message || "Something went wrong";
          if (msg === "DETAIL_NOT_FOUND") {
            handleShowAlert("Detail Not Found");
          } else {
            handleShowAlert(msg);
          }
          setActiveForm("change-password-form");
        } else if (res?.data?.message === "OK") {
          handleShowAlert(`${TEXT_PASSWORD_CHANGED}!`);
          if (isAndroid) {
            const androidUrl = `intent://#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
            window.location.replace(androidUrl);
            setActiveForm(null);
            closeShowAlert();
            return;
          } else if (isIphone || isIpad) {
            const iPhoneUrl = `mybuilderid://`;
            window.location.replace(iPhoneUrl);
            setActiveForm(null);
            closeShowAlert();
            return;
          } else {
            navigate("/", { replace: true });
            setActiveForm("login-form");
          }
        }
      } catch (err) {
        setActiveForm("change-password-form");
      }
    }
  };

  const getPasswordStrength = () => {
    let strength = "";
    if (passwordStrengthCount === 0) strength = "";
    else if (passwordStrengthCount === 1) strength = TEXT_WEAK_PASS;
    else if (passwordStrengthCount > 1 && passwordStrengthCount < 4) strength = TEXT_MEDIUM_PASS;
    else if (passwordStrengthCount === 4) strength = TEXT_STRONG_PASS;
    return strength;
  };

  const getStrengthColor = () => {
    if (passwordStrengthCount === 1) return BIRed;
    if (passwordStrengthCount > 1 && passwordStrengthCount < 4) return BIYellow;
    if (passwordStrengthCount === 4) return BIGreen;
    return BIGrey;
  };

  const getStrengthWidth = () => {
    if (passwordStrengthCount === 1) return "33%";
    if (passwordStrengthCount > 1 && passwordStrengthCount < 4) return "66%";
    if (passwordStrengthCount === 4) return "100%";
    return "0%";
  };

  const handleShowAlert = (text) => {
    let alertObj = {
      showAlert: true,
      title: "",
      text: text
    };
    dispatch(setShowalert(alertObj));
  };

  const closeShowAlert = () => {
    let alertObj = {
      showAlert: false,
      title: "",
      text: ""
    };
    dispatch(setShowalert(alertObj));
  };

  const getLangCode = async (languageCode) => {
    setSelectedLanguage(languageCode);
  };

  useEffect(() => {
    getNotificationToken();
  }, [pathname]);

  // NEW ONE WITH UPDATE
  const getNotificationToken = async () => {
    try {
      if (!("serviceWorker" in navigator)) {
        console.warn("⚠️ Service workers are not supported in this browser");
        return;
      }
      let registration = await navigator.serviceWorker.getRegistration("/");
      if (!registration) {
        // console.log("Registering Service Worker from Login.jsx...");
        registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
          scope: "/"
        });
      }

      if (!registration.active) {
        await new Promise((resolve) => {
          registration.addEventListener("updatefound", () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;
            installingWorker.addEventListener("statechange", () => {
              if (registration.active) resolve();
            });
          });
        });
      }

      const result = await requestNotificationPermission();
      if (result) {
        const token = await getToken();
        if (token) {
          setNotifytoken(token);
          // console.log("✅ Notification token set successfully");
        } else {
          console.warn("⚠️ Failed to get notification token");
        }
      }
    } catch (error) {
      console.error("getNotificationToken-> ⚠️ Error getting notification token:", error);
    }
  };

  // src/firebase.js (or a utils/notifications.js file)
  const requestNotificationPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        // console.log("✅ Notification permission granted.");
        return true;
      } else {
        console.warn("requestNotificationPermission-> ❌ Notification permission denied.");
        // requestNotificationPermission();
        return false;
      }
    } catch (error) {
      console.error(
        "requestNotificationPermission-> ⚠️ Error requesting notification permission:",
        error
      );
      return false;
    }
  };

  useEffect(() => {
    if (pathname.includes("forgot-password")) {
      setActiveForm("change-password-form");
    } else if (pathname.includes("create-account")) {
      setActiveForm("create-account-form");
    } else {
      setActiveForm("login-form");
    }
  }, [pathname]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    async function changeLang() {
      try {
        setChangeLangLoader(true);
        const appType = "Web";
        const multiLangRes = await Getrequestcall(
          `${GET_APP_LABELS_LANGUAGES_DETAILS}/${selectedLanguage}/${appType}`,
          null
        );
        if (multiLangRes?.data?.status == true && multiLangRes?.data?.message == "OK") {
          dispatch(setMultiLanguageData(multiLangRes?.data?.data));
          dispatch(setMultiLanguageCode(selectedLanguage));
        } else if (
          multiLangRes?.response?.data?.status == false &&
          multiLangRes?.response?.data?.message !== "OK"
        ) {
          handleShowAlert(multiLangRes?.response?.data?.message);
        }
        setChangeLangLoader(false);
      } catch (error) {
        setChangeLangLoader(false);
        console.log("changeLang-> Error When Getting Multi Language Data: ", error);
      }
    }
    changeLang();
  }, [selectedLanguage]);

  useEffect(() => {
    sessionStorage.removeItem("logoutClicked");
  }, []);

  return (
    <>
      <Box position="relative">
        {changeLangLoader && (
          <div className="loader-overlay">
            <Loader />
          </div>
        )}

        {showInvitationModal && (
          <ClientInvitation
            showInvitation={showInvitationModal}
            handleClose={handleInviteModalClose}
            overrideLoginData={pendingLoginRes}
          />
        )}

        <Grid
          container
          className="login-container"
          style={{ pointerEvents: changeLangLoader ? "none" : "auto" }}>
          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }} className="login-gfirst">
            <Card className="login-card" sx={{ padding: "20px" }}>
              {activeForm === "login-form" ? (
                <>
                  <Typography variant="h5" component="h2" className="login-text">
                    {TEXT_LOGIN}
                  </Typography>
                  <TextField
                    label={TEXT_EMAIL}
                    name="email"
                    type="text"
                    value={inputValue?.email}
                    onChange={inputValuechange}
                    sx={{ width: "300px" }}
                    className="login-field"
                    variant="outlined"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleLoginClick();
                    }}
                  />
                  <FormControl variant="outlined" className="login-form-control">
                    <InputLabel htmlFor="outlined-adornment-password" className="label">
                      {TEXT_PASSWORD}
                    </InputLabel>
                    <OutlinedInput
                      onChange={inputValuechange}
                      sx={{ width: "300px" }}
                      type={showPassword ? "text" : "password"}
                      id="outlined-adornment-password"
                      name="password"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleLoginClick();
                      }}
                      endAdornment={
                        showVisibilityIcon && (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              edge="end">
                              {showPassword ? (
                                <Visibility className="password-visible-icon" />
                              ) : (
                                <VisibilityOff className="password-visible-icon" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                      label={TEXT_PASSWORD}
                      className="login-field"
                    />
                  </FormControl>
                  <div className="login-footer">
                    <Button
                      size="small"
                      color="primary"
                      style={{ width: "35%" }}
                      disabled={!inputValue?.email}
                      onClick={handleForgotPasswordClick}>
                      {TEXT_FORGOT_PASSWORD}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={!inputValue?.email || !inputValue?.password}
                      onClick={handleLoginClick}
                      loading={isLoading}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleLoginClick();
                      }}>
                      {TEXT_LOGIN}
                    </Button>
                  </div>
                  <TakeTour />
                  <Button variant="text" size="small" onClick={handleCreateAccount}>
                    {TEXT_CREATE_NEW_ACCOUNT}
                  </Button>
                </>
              ) : activeForm === "forgot-password-form" ? (
                <>
                  <Typography variant="h5" component="h2" className="login-text">
                    Forgot Password
                  </Typography>
                  <TextField
                    label="Email"
                    name="email"
                    defaultValue={inputValue?.email}
                    onChange={inputValuechange}
                    sx={{ width: "300px" }}
                    className="login-field"
                    variant="outlined"
                  />

                  <div className="login-footer">
                    <Button
                      size="small"
                      color="primary"
                      // style={{ width: "35%" }}
                      onClick={() => setActiveForm("login-form")}>
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleContinueClick}
                      style={{ background: BIBlue }}>
                      Continue
                    </Button>
                  </div>
                  <Button variant="text" size="small" onClick={() => handleGotoResetCode()}>
                    I have a reset code
                  </Button>
                </>
              ) : activeForm === "reset-code-form" ? (
                <>
                  <TextField
                    label="Reset Code"
                    name="Reset Code"
                    value={resetCode}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      setResetCode(value);
                    }}
                    sx={{ width: "300px" }}
                    className="login-field"
                    variant="outlined"
                  />

                  <Typography
                    variant="body2"
                    color={BIBlue}
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleResendCodeClick()}
                    alignSelf={"end"}>
                    Didn't receive a code?
                  </Typography>

                  <div className="login-footer">
                    <Button
                      size="small"
                      sx={{ color: BIBlue }}
                      onClick={() => setActiveForm("forgot-password-form")}>
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        background: resetCode?.length !== 6 ? BIGrey : BIBlue
                      }}
                      onClick={handleResetClick}
                      disabled={resetCode?.length !== 6}>
                      Reset
                    </Button>
                  </div>
                </>
              ) : activeForm === "change-password-form" ? (
                <>
                  <img
                    src={BuildIdLogo}
                    alt="logo"
                    style={{
                      width: "150px",
                      height: "auto",
                      alignSelf: "center",
                      display: window.innerWidth >= 768 ? "none" : "block"
                    }}
                  />
                  <TextField
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    label={TEXT_NEW_PASS_LABEL}
                    name="password"
                    value={inputValue?.password}
                    fullWidth
                    onChange={(e) => {
                      let count = 0;
                      if (e.target.value.length >= 6) count += 1;
                      if (e.target.value.match(/(?=.*\d)/)) count += 1;
                      if (e.target.value.match(/(?=.*[A-Z])/)) count += 1;
                      if (e.target.value.match(/(?=.*[a-z])/)) count += 1;
                      // setPassword(e.target.value);
                      inputValuechange(e);
                      setPasswordStrengthCount(count);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            tabIndex="-1" // Unfocusable button
                            onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />

                  <Box>
                    {/* Password strength header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Typography variant="body2">{TEXT_PASS_STRENGTH}</Typography>
                      <Typography
                        variant="body2"
                        style={{
                          color: getStrengthColor()
                        }}>
                        {getPasswordStrength()}
                      </Typography>
                    </Box>

                    {/* Strength bar */}
                    <Box
                      sx={{
                        width: "100%",
                        height: 5,
                        borderRadius: 1,
                        backgroundColor: BIGrey
                      }}>
                      <Box
                        sx={{
                          height: 5,
                          borderRadius: 1,
                          width: getStrengthWidth(),
                          backgroundColor: getStrengthColor()
                        }}
                      />
                    </Box>
                  </Box>

                  <Stack spacing={1} className="input-container">
                    {/* At least 6 characters */}
                    <Stack direction="row" alignItems="center">
                      {inputValue?.password.length >= 6 ? (
                        <Check style={{ color: BIGreen }} className="icon-position" />
                      ) : (
                        <Clear
                          style={{
                            color: inputValue?.password.length === 0 ? BIGrey : BIRed
                          }}
                          className="icon-position"
                        />
                      )}
                      <Typography
                        variant="body2"
                        style={{
                          color:
                            inputValue?.password === ""
                              ? BIGrey
                              : inputValue?.password.length >= 6
                                ? BIGreen
                                : BIRed
                        }}>
                        {TEXT_CHARACTERS}
                      </Typography>
                    </Stack>

                    {/* At least 1 number */}
                    <Stack direction="row" alignItems="center">
                      {/(?=.*\d)/.test(inputValue?.password) ? (
                        <Check style={{ color: BIGreen }} className="icon-position" />
                      ) : (
                        <Clear
                          style={{
                            color: inputValue?.password.length === 0 ? BIGrey : BIRed
                          }}
                          className="icon-position"
                        />
                      )}
                      <Typography
                        variant="body2"
                        style={{
                          color:
                            inputValue?.password === ""
                              ? BIGrey
                              : /(?=.*\d)/.test(inputValue?.password)
                                ? BIGreen
                                : BIRed
                        }}>
                        {TEXT_NUMBER}
                      </Typography>
                    </Stack>

                    {/* At least 1 capital letter */}
                    <Stack direction="row" alignItems="center">
                      {/(?=.*[A-Z])/.test(inputValue?.password) ? (
                        <Check style={{ color: BIGreen }} className="icon-position" />
                      ) : (
                        <Clear
                          style={{
                            color: inputValue?.password.length === 0 ? BIGrey : BIRed
                          }}
                          className="icon-position"
                        />
                      )}
                      <Typography
                        variant="body2"
                        style={{
                          color:
                            inputValue?.password === ""
                              ? BIGrey
                              : /(?=.*[A-Z])/.test(inputValue?.password)
                                ? BIGreen
                                : BIRed
                        }}>
                        {TEXT_CAPITAL_LETTER}
                      </Typography>
                    </Stack>

                    {/* At least 1 lowercase letter */}
                    <Stack direction="row" alignItems="center">
                      {/(?=.*[a-z])/.test(inputValue?.password) ? (
                        <Check style={{ color: BIGreen }} className="icon-position" />
                      ) : (
                        <Clear
                          style={{
                            color: inputValue?.password.length === 0 ? BIGrey : BIRed
                          }}
                          className="icon-position"
                        />
                      )}
                      <Typography
                        variant="body2"
                        style={{
                          color:
                            inputValue?.password === ""
                              ? BIGrey
                              : /(?=.*[a-z])/.test(inputValue?.password)
                                ? BIGreen
                                : BIRed
                        }}>
                        {TEXT_LOWER_LETTER}
                      </Typography>
                    </Stack>
                  </Stack>

                  <div className="input-container">
                    <TextField
                      type={showRetypePassword ? "text" : "password"}
                      variant="outlined"
                      label={TEXT_CONFIRM_PASS_LABEL}
                      fullWidth
                      value={retypePassword}
                      onChange={(event) => setRetypePassword(event.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              tabIndex="-1" // Unfocusable button
                              onClick={() => setShowRetypePassword(!showRetypePassword)}>
                              {showRetypePassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </div>

                  <Stack spacing={1} className="input-container">
                    <Stack direction="row" alignItems="center">
                      {retypePassword === "" || isMatch ? (
                        <>
                          <Check
                            style={{ color: isMatch ? BIGreen : BIGrey }}
                            className="icon-position"
                          />
                          <Typography variant="body2" style={{ color: isMatch ? BIGreen : BIGrey }}>
                            {TEXT_PASSWORD}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Clear style={{ color: BIRed }} className="icon-position" />
                          <Typography variant="body2" style={{ color: BIRed }}>
                            {TEXT_PASSWORD}
                          </Typography>
                        </>
                      )}
                    </Stack>
                  </Stack>

                  <div className="login-footer" style={{ alignSelf: "center" }}>
                    {/* <Button
                    size="small"
                    sx={{ color: BIBlue }}
                    onClick={() => setActiveForm("reset-code-form")}
                  >
                    Back
                  </Button> */}
                    <Button
                      variant="contained"
                      onClick={handleChangePassword}
                      disabled={
                        passwordStrengthCount === 4 && inputValue?.password === retypePassword
                          ? false
                          : true
                      }
                      style={{
                        background:
                          passwordStrengthCount === 4 && inputValue?.password === retypePassword
                            ? BIBlue
                            : BILightGrey
                      }}>
                      {TEXT_RESET_PASSWORD}
                    </Button>
                  </div>
                </>
              ) : activeForm === "isLoading" ? (
                <Loader />
              ) : null}
            </Card>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }} className="login-gsecond">
            <div className="logo-info">
              <img src={BuildIdLogo} alt="" className="buildlogo-img" />
              <Typography className="info-text">{TEXT_DESCIPTION_1}</Typography>
              <Typography className="info-text">{TEXT_DESCIPTION_2}</Typography>
            </div>
          </Grid>
        </Grid>
      </Box>
      <FormControl
        sx={{
          position: "fixed",
          bottom: 10,
          right: 10,
          zIndex: 5555,
          minWidth: 120,
          borderRadius: "4px",
          boxShadow: 3
        }}
        size="small">
        <Select
          value={selectedLanguage}
          onChange={(e) => getLangCode(e.target.value)}
          displayEmpty
          inputProps={{ "aria-label": "Select language" }}
          MenuProps={{
            anchorOrigin: {
              vertical: "top",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            PaperProps: {
              style: {
                maxHeight: 250
              }
            }
          }}>
          {labelArray.map((item) => (
            <MenuItem key={item.code} value={item.code}>
              {item.language}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <SelectOrganizationDialog
        open={showClientModal}
        onClose={handleLogoutInModal}
        clients={clientList}
        onSelectClient={handleSelectClient}
        onViewInvite={handleViewPendingInvite}
        pendingInvitations={pendingLoginRes?.userInformation?.PendingInvitations || []}
        onLogout={handleLogoutInModal}
        showLogout={true}
      />
    </>
  );
}
